<div style="text-align: center; margin-top: 20%;">
    @if (isCheckingForNewVersion) {
        <p style="color: #666;">Checking for the latest version&hellip;</p>
    } @else {
        <svg width="600" height="200" xmlns="http://www.w3.org/2000/svg">
            <!-- Background Rectangle -->
            <rect width="600" height="200" fill="#f0f0f0" />
            <!-- 404 Text -->
            <text x="50%" y="40%" font-size="60" text-anchor="middle" fill="#333">404</text>
            <!-- Page Not Found Text -->
            <text x="50%" y="70%" font-size="40" text-anchor="middle" fill="#777">Page Not Found</text>
        </svg>

        @if (attemptedUrl) {
            <p style="margin-top: 20px; color: #666;">
                The requested URL <strong>{{ attemptedUrl }}</strong> was not found.
            </p>
        }
    }
</div>
